import { configureStore } from "@reduxjs/toolkit";
import allModalSlice from "./slices/allModalSlice";
import allDrawerSlice from "./slices/allDrawerSlice";
import { rtkQuerieSetup } from "./services/rtkQuerieSetup";

export const store = configureStore({
  reducer: {
    allCommonModal: allModalSlice,
    allCommonDrawer: allDrawerSlice,
    [rtkQuerieSetup.reducerPath]: rtkQuerieSetup.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQuerieSetup.middleware),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;